"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputDatePopup = InputDatePopup;
exports.InputMonth = InputMonth;
exports.WEEKDAYS_SHORT = exports.WEEKDAYS_LONG = exports.MONTHS_SHORT = exports.MONTHS = void 0;
exports.default = InputDate;
exports.fromMonthParam = fromMonthParam;
exports.localeUtils = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactDatepicker = _interopRequireWildcard(require("react-datepicker"));
var _th = _interopRequireDefault(require("date-fns/locale/th"));
var _dateFns = require("date-fns");
var _utils = require("../utils");
var _Icon = _interopRequireDefault(require("../Icon"));
var _Input = require("./Input");
var _index = require("../index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
(0, _reactDatepicker.registerLocale)('th', _th.default);

// ----- INTERFACE

// ----- UTILS

function fromMonthParam(date) {
  if (date) {
    var d = date.split('_');
    if (d.length === 2) return [(0, _utils.todate)(d[0] + '-01'), (0, _utils.todate)(d[1] + '-01')];
    return (0, _utils.todate)(d[0] + '-01');
  }
  return '';
}
var WEEKDAYS_LONG = {
  en: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  th: ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์']
};
exports.WEEKDAYS_LONG = WEEKDAYS_LONG;
var WEEKDAYS_SHORT = {
  en: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  th: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.']
};
exports.WEEKDAYS_SHORT = WEEKDAYS_SHORT;
var MONTHS = {
  en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  th: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม']
};
exports.MONTHS = MONTHS;
var MONTHS_SHORT = {
  en: ['Jan', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  th: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.']
};
exports.MONTHS_SHORT = MONTHS_SHORT;
var localeUtils = {
  formatDay: function formatDay(d) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
    return "".concat(WEEKDAYS_LONG[locale][d.getDay()], ", ").concat(d.getDate(), " ").concat(MONTHS[locale][d.getMonth()], " ").concat(d.getFullYear());
  },
  formatMonthTitle: function formatMonthTitle(d) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
    return "".concat(MONTHS[locale][d.getMonth()], " ").concat(d.getFullYear());
  },
  formatWeekdayShort: function formatWeekdayShort(i) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
    return WEEKDAYS_SHORT[locale][i];
  },
  formatWeekdayLong: function formatWeekdayLong(i) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
    return WEEKDAYS_LONG[locale][i];
  },
  getFirstDayOfWeek: function getFirstDayOfWeek() {
    return 0;
  }
};

// ----- COMPONENT
exports.localeUtils = localeUtils;
function _renderCustomHeader(c, day) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'un-popup-date-header'
  }, c.prevMonthButtonDisabled ? /*#__PURE__*/React.createElement("div", {
    className: 'mr-auto'
  }) : /*#__PURE__*/React.createElement(_Icon.default, {
    button: true,
    onClick: c.decreaseMonth,
    name: 'chevron-left mr-auto'
  }), /*#__PURE__*/React.createElement("select", {
    value: (0, _dateFns.getMonth)(c.date),
    onChange: function onChange(e) {
      return c.changeMonth(e.target.value);
    }
  }, MONTHS[_utils.locale].map(function (n, x) {
    return /*#__PURE__*/React.createElement("option", {
      key: n,
      value: x
    }, n);
  })), /*#__PURE__*/React.createElement("select", {
    value: (0, _dateFns.getYear)(c.date),
    onChange: function onChange(e) {
      return c.changeYear(e.target.value);
    }
  }, _toConsumableArray(new Array(100)).map(function (_, d) {
    return d + (0, _dateFns.getYear)(day || new Date()) - 75;
  }).map(function (n) {
    return /*#__PURE__*/React.createElement("option", {
      key: n,
      value: n
    }, n + (_utils.locale === 'th' ? 543 : 0));
  })), c.nextMonthButtonDisabled ? /*#__PURE__*/React.createElement("div", {
    className: 'ml-auto'
  }) : /*#__PURE__*/React.createElement(_Icon.default, {
    button: true,
    onClick: c.increaseMonth,
    name: 'chevron-right ml-auto'
  }));
}
function InputDate(props) {
  var value = props.value,
    valueFormat = props.valueFormat,
    icon = props.icon,
    iconRight = props.iconRight,
    label = props.label,
    fixWidth = props.fixWidth,
    classBox = props.classBox;
  var _useState = (0, React.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    day = _useState2[0],
    setDay = _useState2[1];
  var coverRef = (0, React.useRef)(null);
  var _onChange = function onChange(day) {
    if (props.onChange !== undefined) props.onChange(day);
  };
  var onClear = function onClear() {
    return _onChange(null);
  };
  var onChangeText = function onChangeText(e) {
    var _e$target$value;
    var value = (_e$target$value = e.target.value) === null || _e$target$value === void 0 ? void 0 : _e$target$value.replaceAll('.', ':');
    var pattern = props.time ? /^\d{1,2}\/\d{1,2}\/\d{4} \d{2}:\d{2}$/g : /^\d{1,2}\/\d{1,2}\/\d{4}$/g;
    if (pattern.test(value)) {
      var _value$split = value.split(' '),
        _value$split2 = _slicedToArray(_value$split, 2),
        _date = _value$split2[0],
        time = _value$split2[1];
      var dates = _date.split('/');
      var y = (0, _utils.num)(dates[2]),
        m = (0, _utils.num)(dates[1]),
        d = (0, _utils.num)(dates[0]);
      if (y > 2500) y -= 543;
      if (y > 1900 && m >= 1 && m <= 12 && d >= 1 && d <= 31) {
        var _times$, _times$2;
        var times = time && time.split(':');
        _onChange(new Date(y, m - 1, d, (_times$ = times[0]) !== null && _times$ !== void 0 ? _times$ : 0, (_times$2 = times[1]) !== null && _times$2 !== void 0 ? _times$2 : 0, 0, 0));
        setTimeout(function () {
          if (coverRef.current) {
            var _input = coverRef.current.getElementsByTagName('input');
            if (_input && _input.length > 0) _input[0].focus();
          }
        }, 100);
      }
    }
    //console.log(value, (/^[0-9/-]+$/g.test(value)))
    //if (!(/^[0-9/-]+$/g.test(value))) e.target.value = ''
  };

  var onBlurText = (0, _index.debounce)(function (e) {
    if (e.target.value !== (0, _utils.date)(value, valueFormat || (!!props.time ? 'Pt' : 'P'))) {
      e.target.value = '';
    }
  }, 200);

  // USE EFFECT

  (0, React.useEffect)(function () {
    var v = !(0, _utils.isEmpty)(value) && (0, _utils.todate)(value);
    var ok = (0, _utils.isValidDate)(v);
    setDay(ok ? v : null);
  }, [value]);

  // ----- RENDER

  var inputProp = {
    value: day || '',
    onChange: function onChange(date) {
      return _onChange(date);
    },
    timeIntervals: props.timeIntervals,
    time: !!props.time
  };
  // key={'i_' + dbdate(value)}
  var input = /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)((0, _Input.createInputboxClass)('un-input-date', props), !(0, _utils.isEmpty)(day) && '-focus', fixWidth && '-fix-width', !!props.time && '-time')
  }, !!icon && /*#__PURE__*/React.createElement("div", {
    className: "un-inputbox-pend"
  }, (0, _Input.testIcon)(icon, 'calendar')), /*#__PURE__*/React.createElement("div", {
    ref: coverRef,
    className: "un-inputbox-control"
  }, /*#__PURE__*/React.createElement(InputDatePopup, inputProp, function (value, onClick, ref) {
    if (props.botton) return /*#__PURE__*/React.createElement("div", {
      className: "un-inputbox-text",
      onClick: onClick
    }, (0, _utils.date)(value, valueFormat || (!!props.time ? 'Pt' : 'P')));
    return /*#__PURE__*/React.createElement("input", {
      id: props.id,
      type: 'text',
      className: "un-inputbox-input",
      ref: ref,
      onClick: onClick,
      defaultValue: (0, _utils.date)(value, valueFormat || (!!props.time ? 'Pt' : 'P')),
      onChange: onChangeText,
      onBlur: onBlurText
    });
  }), !props.form && !!label && (0, _Input.createInputboxLabel)(label)), !props.noClear && !!day && /*#__PURE__*/React.createElement("div", {
    className: "un-inputbox-pend"
  }, /*#__PURE__*/React.createElement(_Icon.default, {
    name: 'times',
    className: 'un-inputbox-clear',
    onClick: onClear
  })), !!iconRight && /*#__PURE__*/React.createElement("div", {
    className: "un-inputbox-pend"
  }, (0, _Input.testIcon)(iconRight, 'calendar')));
  if (props.form) return (0, _Input.createFormitem)(input, props);
  if (typeof classBox === 'string') return /*#__PURE__*/React.createElement("div", {
    className: classBox
  }, input);
  return input;
}
function InputDatePopup(props) {
  var day = props.value;
  var InputNative = /*#__PURE__*/(0, React.forwardRef)(function (e, ref) {
    return props.children(e.value, e.onClick, ref);
  });
  var popperModifiers = [];
  if (props.popupOffset) popperModifiers.push({
    name: 'offset',
    options: {
      offset: props.popupOffset
    }
  });
  var inputProp = {
    locale: _utils.locale,
    portalId: 'root-portal',
    customInput: /*#__PURE__*/React.createElement(InputNative, null),
    dateFormat: 'yyyy-MM-dd HH:mm:ss',
    selected: day || '',
    onChange: function onChange(date) {
      return props.onChange(date);
    },
    closeOnScroll: true,
    timeIntervals: props.timeIntervals || 10,
    showTimeSelect: !!props.time,
    popperClassName: 'un-popup-date',
    popperModifiers: popperModifiers,
    renderCustomHeader: function renderCustomHeader(c) {
      return _renderCustomHeader(c, day);
    }
  };
  return /*#__PURE__*/React.createElement(_reactDatepicker.default, inputProp);
}
function InputMonth(props) {
  var value = props.value,
    icon = props.icon,
    label = props.label,
    iconRight = props.iconRight,
    fixWidth = props.fixWidth,
    classBox = props.classBox;
  var onChange = function onChange(day) {
    if (props.onChange !== undefined) props.onChange(day);
  };
  var onClear = function onClear() {
    return onChange(null);
  };

  // ----- RENDER

  //const InputNative = forwardRef((e: any, ref: any) =>)
  var InputNative = /*#__PURE__*/(0, React.forwardRef)(function (e, r) {
    return /*#__PURE__*/React.createElement("div", {
      className: "un-inputbox-input",
      ref: r,
      onClick: e.onClick,
      children: (0, _utils.date)(value, 'M').split(' ').slice(1).join(' ')
    });
  });
  var inputProp = {
    locale: _utils.locale,
    portalId: 'root-portal',
    customInput: /*#__PURE__*/React.createElement(InputNative, null),
    selected: value || '',
    onChange: function onChange(date) {
      return props.onChange(date);
    },
    closeOnScroll: true,
    popperClassName: 'un-popup-date -month',
    renderCustomHeader: function renderCustomHeader(c, day) {
      return /*#__PURE__*/React.createElement("div", {
        className: 'un-popup-date-header -month'
      }, c.prevYearButtonDisabled ? /*#__PURE__*/React.createElement("div", {
        className: 'mr-auto'
      }) : /*#__PURE__*/React.createElement(_Icon.default, {
        button: true,
        onClick: c.decreaseYear,
        name: 'chevron-left mr-auto'
      }), /*#__PURE__*/React.createElement("div", {
        className: '_name'
      }, (0, _dateFns.getYear)(c.date) + (_utils.locale === 'th' ? 543 : 0)), c.nextYearButtonDisabled ? /*#__PURE__*/React.createElement("div", {
        className: 'ml-auto'
      }) : /*#__PURE__*/React.createElement(_Icon.default, {
        button: true,
        onClick: c.increaseYear,
        name: 'chevron-right ml-auto'
      }));
    },
    showMonthYearPicker: true,
    showFullMonthYearPicker: true,
    showTwoColumnMonthYearPicker: true
  };
  var input = /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)((0, _Input.createInputboxClass)('un-input-month', props), !(0, _utils.isEmpty)(value) && '-focus', fixWidth && '-fix-width')
  }, !!icon && /*#__PURE__*/React.createElement("div", {
    className: "un-inputbox-pend"
  }, (0, _Input.testIcon)(icon, 'calendar-week')), /*#__PURE__*/React.createElement("div", {
    className: "un-inputbox-control"
  }, /*#__PURE__*/React.createElement(_reactDatepicker.default, inputProp), (0, _Input.createInputboxLabel)(label)), !props.noClear && !!value ? /*#__PURE__*/React.createElement("div", {
    className: "un-inputbox-pend"
  }, /*#__PURE__*/React.createElement(_Icon.default, {
    name: 'times',
    className: 'un-inputbox-clear',
    onClick: onClear
  })) : null, !!iconRight && /*#__PURE__*/React.createElement("div", {
    className: "un-inputbox-pend"
  }, (0, _Input.testIcon)(iconRight, 'calendar-week')));
  if (typeof classBox === 'string') return /*#__PURE__*/React.createElement("div", {
    className: classBox
  }, input);
  return input;
}